import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'

import { doSignout } from '../../Utils/api'

import { Flex, FlexColumn } from '../Reusable/Container'
import { isAnyAccountLockedOrClosed, getBPAccountsWithAccess } from '../../Utils/util'

import { Text, Tag } from '../Reusable/Text'
import { Image } from '../Reusable/Image'
import { Button } from '../Reusable/Button'
import ModalClose from '../../Images/modal-close.png'
import FullScreenModal from '../Reusable/FullScreenModal'
import { StyledExtLink, StyledLink } from '../Reusable/Link'
import Lock from '../../Images/lock-locked.svg'
import AionText from "../../Images/aion-logo-text.png"


class Index extends Component {

    componentDidMount() {
        var Accounts = getBPAccountsWithAccess("Transactions")
        console.log("FrozenAccounts", Accounts)
        var showFrozenAccountModal = isAnyAccountLockedOrClosed(Accounts)
        this.setState({ showFrozenAccountModal })
    }

    signout = () => {
        this.props.doSignout(this.props.history);
    }

    render() {
        const { store } = this.props;
        const fontSize = "18px"


        return (
            <FlexColumn fullHeight fullWidth between gap="4px">
                <Flex start style={{ margin: '24px 28px 12px 16px' }}>
                    <Image src={this.props.theme.logo.symbol} />
                    <img style={{ marginLeft: 8 }} height={17} width={36} src={AionText} />
                </Flex>
                <FlexColumn center gap="4px" grow fullWidth>
                    <Image src={Lock} height='100px' width='100px' />
                    <Flex centerH gap="4px" style={{ marginTop: 24, marginBottom: 4 }}>
                        <Text size={fontSize} weight='600'>Your bank account is currently frozen for security reasons.</Text>
                    </Flex>
                    <Text size={fontSize}>We take proactive measures to protect your funds and ensure your financial safety. </Text>

                    <Flex centerH gap="4px">
                        <Text size={fontSize}>Reach out to us at </Text>
                        <StyledExtLink
                            target="_blank"
                            href="mailto:contact@aionfi.com"
                            style={{ textDecoration: "underline", fontSize }}
                        >
                            contact@aionfi.com
                        </StyledExtLink>
                        <Text size={fontSize}>for more details or next steps. </Text>
                    </Flex>
                    <Button solid permtype="Override" onClick={() => this.signout()} text='Log Out' margin='24px 0 0' />
                </FlexColumn>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        doSignout: (history) => dispatch(doSignout(history))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))